export default __webpack_public_path__ + "static/media/tenant.74b92962.jpeg";